// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.select_container__4sQk7 {
    position: relative;
    -webkit-user-select: none;
            user-select: none;
    font-weight: 500;
}

.select_dropdownButton__rTfLw {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 4px 6px;
    max-width: 150px;
    min-width: 150px;
    font-size: 16px;
    border: 1px solid #ccc;
    border-radius: 8px;
    background-color: #F6F6F6;
    cursor: pointer;
    color: #8B8B8B;
}

.select_dropdownButton__rTfLw:hover,
.select_dropdownButton__rTfLw:focus {
    border-color: #6B768C;
}

.select_dropdownOptions__drXAU {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    display: none;
    background-color: #fff;
    border: 1px solid #ccc;
    border-top: none;
    border-radius: 0 0 8px 8px;
    cursor: pointer;
    z-index: 100;
    max-height: 200px;
    overflow-y: scroll;
    color: #8487A7;
}

.select_option__44amW {
    padding: 9px 10px 9px 10px;
    border-bottom: 1px solid #D1D5DB;
    text-align: left;
    display: flex;
    align-items: center;
}

.select_option__44amW:last-child {
    border-bottom: none;
}

.select_option__44amW:hover {
    background-color: #e5e5e5;
}

.select_show__907Ry {
    display: block;
}

.select_checkbox__xRJfZ {
    width: 20px;
    height: 20px;
    border: 1px solid #C7D1E7;
    border-radius: 3px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 8px;
    background-color: white;
    cursor: pointer;
}

.select_checkbox__xRJfZ.select_selected__b4zJ8 {
    background-color: #40bf8a;
    border-color: #40bf8a;
}

.select_selected__b4zJ8 {
    background-color: #EFF5FF;
    color: #2E7CF3;
}

.select_searchInput__3xMu5 {
    outline: none;
    border: none;
    font-size: inherit;
    background-color: transparent;
    cursor: text;
    white-space: nowrap;
    min-width: 100px;
    text-align: left;
    padding: 0 0 0 0.5rem;
    color: #000;
}
`, "",{"version":3,"sources":["webpack://./src/components/ajonjolib/inputs/select/select.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,yBAAiB;YAAjB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,sBAAsB;IACtB,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;IACf,cAAc;AAClB;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,aAAa;IACb,sBAAsB;IACtB,sBAAsB;IACtB,gBAAgB;IAChB,0BAA0B;IAC1B,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,0BAA0B;IAC1B,gCAAgC;IAChC,gBAAgB;IAChB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,6BAA6B;IAC7B,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,qBAAqB;IACrB,WAAW;AACf","sourcesContent":[".container {\n    position: relative;\n    user-select: none;\n    font-weight: 500;\n}\n\n.dropdownButton {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 4px 6px;\n    max-width: 150px;\n    min-width: 150px;\n    font-size: 16px;\n    border: 1px solid #ccc;\n    border-radius: 8px;\n    background-color: #F6F6F6;\n    cursor: pointer;\n    color: #8B8B8B;\n}\n\n.dropdownButton:hover,\n.dropdownButton:focus {\n    border-color: #6B768C;\n}\n\n.dropdownOptions {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    right: 0;\n    display: none;\n    background-color: #fff;\n    border: 1px solid #ccc;\n    border-top: none;\n    border-radius: 0 0 8px 8px;\n    cursor: pointer;\n    z-index: 100;\n    max-height: 200px;\n    overflow-y: scroll;\n    color: #8487A7;\n}\n\n.option {\n    padding: 9px 10px 9px 10px;\n    border-bottom: 1px solid #D1D5DB;\n    text-align: left;\n    display: flex;\n    align-items: center;\n}\n\n.option:last-child {\n    border-bottom: none;\n}\n\n.option:hover {\n    background-color: #e5e5e5;\n}\n\n.show {\n    display: block;\n}\n\n.checkbox {\n    width: 20px;\n    height: 20px;\n    border: 1px solid #C7D1E7;\n    border-radius: 3px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-right: 8px;\n    background-color: white;\n    cursor: pointer;\n}\n\n.checkbox.selected {\n    background-color: #40bf8a;\n    border-color: #40bf8a;\n}\n\n.selected {\n    background-color: #EFF5FF;\n    color: #2E7CF3;\n}\n\n.searchInput {\n    outline: none;\n    border: none;\n    font-size: inherit;\n    background-color: transparent;\n    cursor: text;\n    white-space: nowrap;\n    min-width: 100px;\n    text-align: left;\n    padding: 0 0 0 0.5rem;\n    color: #000;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `select_container__4sQk7`,
	"dropdownButton": `select_dropdownButton__rTfLw`,
	"dropdownOptions": `select_dropdownOptions__drXAU`,
	"option": `select_option__44amW`,
	"show": `select_show__907Ry`,
	"checkbox": `select_checkbox__xRJfZ`,
	"selected": `select_selected__b4zJ8`,
	"searchInput": `select_searchInput__3xMu5`
};
export default ___CSS_LOADER_EXPORT___;
